
/* -------------------------------------------------------------------------------- *\
|                               getversion
\* -------------------------------------------------------------------------------- */
export const getversion = (): string =>
{
    return "hpv2-redirection @mclloyd 2026 - version 2.0.6";
}
